<template lang="pug">
div
  app-modal-visualiza-pdf(
    v-if="showModalVisualizaPdf",
    @closeModal="closeModalVisualizaPdf",
    :titulo="tituloModal",
    :tipo="tipoTitulo",
    :conteudo="conteudoModal",
    :isProcesso="true"
  )
  app-modal-desarquivar-processo(
    v-if="showModalDesarquivarProcesso && idProcesso !== null",
    :idProcesso="idProcesso",
    :numeroProcesso="numeroProcesso",
    :processo="processo"
    @closeModal="showModalDesarquivarProcesso = false"
    @refresh="refresh"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppListagem from '@/components/AppListagem'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalDesarquivarProcesso from '@/screens/analise/components/modal/AppModalDesarquivarProcesso'
import AppModalVisualizaPdf from '../components/AppModalVisualizaPdf.vue'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalDesarquivarProcesso,
    AppModalVisualizaPdf

  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('PROCESSO_ARQUIVADO'),
      idProcesso: null,
      processo: {},
      showModalVisualizarProcesso: false,
      items: [],
      protocolo: '',
      tipoProcesso: '',
      conteudoModal: '',
      showModalVisualizaPdf: false,
      totalElements: 0,
      showModalDesarquivarProcesso: false,
      showModalResponsavel: false,
      tipoTitulo: '',
      tituloModal: '',
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.ARQUIVADO || [],
        filtroArquivadosGac: filtro?.filtroArquivadosGac?.ARQUIVADO || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 6, acoes: [] },
        { id: 4, titulo: 'Data de Arquivamento', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 5, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        {
          id: 6, titulo: 'Ações', propriedade: 'tipo', ordem: 7, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Desarquivar', icone: 'fa-folder-open', codigo: 'DESARQUIVAR', ordem: 2, show: this.showDesarquivarProcesso },
            { id: 3, nome: 'Cancelar DAE', icone: 'fa-exclamation-triangle', codigo: 'CANCELAR_DAE', ordem: 3, show: this.showCancelarDaeDesarquivamento },
            { id: 4, nome: 'Visualizar Ofício', icone: 'fa-eye', codigo: 'VIZUALIZAR_OFICIO', ordem: 1, show: this.showVisualizarOficio }
          ]
        }
      ],
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  methods: {
    ...mapActions({
      cancelarBoletoDesarquivamento: 'processo/cancelarBoletoDesarquivamento'
    }),
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.setDadosProcesso(item)
      this.showModalVisualizarProcesso = true
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    setDadosProcesso (item) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.processo = item
      this.protocolo = item.numeroProtocolo
      this.tipoProcesso = item.tipoCodigo
      this.processo = item
    },
    DESARQUIVAR (_this, { item }) {
      this.setDadosProcesso(item)
      this.showModalDesarquivarProcesso = true
    },
    CANCELAR_DAE (_this, { item }) {
      this.setDadosProcesso(item)
      this.$confirm(
        'Ao confirmar essa ação, o boleto do processo será cancelado. Tem certeza que deseja confirmar essa ação?',
        'Atenção',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(async (action) => {
          await this.cancelarBoletoDesarquivamento(this.numeroProcesso).then((data) => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, `Boleto cancelado com sucesso!`)
          }).catch(() => {
            this.showNotificacao(this.$messages.TIPO_ERRO, this.$messages.TITULO_ERRO, `Erro ao cancelar boleto. Tente novamento mais tarder`)
          })
        }).catch(() => {
        }).finally(() => {
          this.refresh()
        })
    },
    VIZUALIZAR_OFICIO (_this, { item }) {
      this.tituloModal = 'Minuta do Ofício'
      this.tipoTitulo = 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
      this.conteudoModal = item.id
      this.showModalVisualizaPdf = true
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    },
    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario?.perfilSelecionado?.codigo)
    }

  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaProcessosArquivadosListagemSetores.vue